module.exports = __webpack_public_path__ + "static/media/Katelyn.6b416817.jpg";